const config = {
  considerAdminAccess:
    process.env.REACT_APP_CONSIDER_TICKET_ADMIN_ACCESS,
};
export default config;
